const axios = require('axios');

export default class SchedulePromotionVehicleCategory {
  constructor(resource) {
    this._resource = resource;
  }

  getOnlyActive(page) {
    return this._resource('promotion_category/active')
      .get({ page })
      .then(res => res.json());
  }

  getOnlyInactive(page) {
    return this._resource('promotion_category/inactive')
      .get({ page })
      .then(res => res.body);
  }

  create(obj) {
    obj.promotion_value = obj.promotion_value.replace(',', '');
    while (obj.promotion_value.includes('.')) {
      obj.promotion_value = obj.promotion_value.replace('.', '');
    }

    obj.basic_value = obj.basic_value.replace(',', '');
    while (obj.basic_value.includes('.')) {
      obj.basic_value = obj.basic_value.replace('.', '');
    }

    obj.km_promotion_value = obj.km_promotion_value.replace(',', '');
    while (obj.km_promotion_value.includes('.')) {
      obj.km_promotion_value = obj.km_promotion_value.replace('.', '');
    }

    obj.km_basic_value = obj.km_basic_value.replace(',', '');
    while (obj.km_basic_value.includes('.')) {
      obj.km_basic_value = obj.km_basic_value.replace('.', '');
    }

    return this._resource('promotion_category/create')
      .save(obj)
      .then(res => res.json());
  }

  delete(schedulePromotionVehicleCategoryId) {
    return this._resource(
      `promotion_category/delete/${schedulePromotionVehicleCategoryId}`
    )
      .delete()
      .then(res => res.json());
  }
}
